module.exports = __webpack_public_path__ + "img/p2-4.83216a52.png";